export const selectFilters = [
  {
    filterKey: 'statusCodes',
    label: 'Status code',
    placeholder: 'All codes',
    id: 'filter-status-codes',
    minWidth: '240px',
  },
];

export const allSelectFilters = [
  {
    filterKey: 'statusCodes',
    type: 'multiSelect',
    label: 'Status code',
    placeholder: 'All codes',
    id: 'filter-status-codes-expanded',
  },
  {
    filterKey: 'eventType',
    type: 'select',
    label: 'Payload type',
    placeholder: 'All types',
    id: 'filter-event-type-expanded',
    options: [
      { value: 'VehicleState', label: 'Vehicle state' },
      { value: 'VehicleError', label: 'Vehicle error' },
    ],
  },
];

export const staticText = {
  apply: 'Apply',
  allDates: 'All dates',
  dateRange: 'Date range',
  reset: 'Reset',
  vehicleId: 'Vehicle ID',
  webhookIdOrName: 'Webhook name / ID',
  logDaysAllowance: logDays => `Your current plan provides access to the most recent ${logDays} day${logDays > 1 ? 's' : ''} of log data.`,
  maxLogDays: logDays => `Logs can be viewed up to the past ${logDays} days.`,
  featureGated: {
    upgrade: '|+|Upgrade@@/team/billing|+| to access more.',
    contactOwnersToUpgrade: 'To access more, contact your team owner to upgrade your plan.',
  },
  allFilters: 'All filters',
  enterVehicleId: 'Enter vehicle ID',
  enterWebhookIdOrName: 'Enter webhook name / ID',
};
